export const parseClients = (clients: any) =>
	clients.map((locker: any) => ({
		id: locker.id,
		label: `${locker.first_name} ${locker.last_name}`
	}))
